import ApiService from '@/services/api.service'


const InventoryItemService = {
    getAll( parameter) {          
      const requestData = {
        method: 'get',
        url: "/MdIpInventoryItems/",
        headers: {
        },
        params: { 
          SearchCriteria: parameter.SearchCriteria,
          PageSize: parameter.PageSize,          
          PageNumber : parameter.PageNumber        
        }
      }     
      return ApiService.customRequest(requestData);         
    },
  
    get(id) {
      return ApiService.get(`/MdIpInventoryItems/${id}`);
    },

    add(data){
      return ApiService.post(`/MdIpInventoryItems`,data)
    },

    delete(id){
      return ApiService.delete(`/MdIpInventoryItems/${id}`)
    },
    
    update(id,data){
      return ApiService.put(`/MdIpInventoryItems/${id}`,data)
    },
   
}
  
  export default InventoryItemService;